import { createSelector } from 'reselect';

import * as loadingState from '@blueberry/constants/loadingState';
import { SCHOOL } from '@blueberry/constants/scoreRecordCategories';

export const types = {
  FETCH_RECORD_CATEGORIES: 'FETCH_RECORD_CATEGORIES',
  FETCH_RECORD_CATEGORIES_SUCCESS: 'FETCH_RECORD_CATEGORIES_SUCCESS',
  FETCH_RECORD_CATEGORIES_FAILURE: 'FETCH_RECORD_CATEGORIES_FAILURE',
  FETCH_SCORE_RECORD_LIST: 'FETCH_SCORE_RECORD_LIST',
  FETCH_SCORE_RECORD_LIST_SUCCESS: 'FETCH_SCORE_RECORD_LIST_SUCCESS',
  FETCH_SCORE_RECORD_LIST_FAILURE: 'FETCH_SCORE_RECORD_LIST_FAILURE',
  CHANGE_RECORD_CATEGORY: 'CHANGE_RECORD_CATEGORY',
  CHANGE_RECORD_CATEGORY_TYPE: 'CHANGE_RECORD_CATEGORY_TYPE',
  FETCH_RECORD_DETAIL: 'FETCH_RECORD_DETAIL',
  FETCH_RECORD_DETAIL_SUCCESS: 'FETCH_RECORD_DETAIL_SUCCESS',
  FETCH_RECORD_DETAIL_FAILURE: 'FETCH_RECORD_DETAIL_FAILURE',
  TOGGLE_RECORD_CONCEPT_CHECKED: 'TOGGLE_RECORD_CONCEPT_CHECKED',
  TOGGLE_RECORD_CONCEPT_CHECKED_SUCCESS:
    'TOGGLE_RECORD_CONCEPT_CHECKED_SUCCESS',
  TOGGLE_RECORD_CONCEPT_CHECKED_FAILURE:
    'TOGGLE_RECORD_CONCEPT_CHECKED_FAILURE',
  SET_STUDENT_ID: 'SET_STUDENT_ID',
  SET_STUDENT_NAME: 'SET_STUDENT_NAME',
};

export const fetchRecordCategories = () => ({
  type: types.FETCH_RECORD_CATEGORIES,
});

export const fetchRecordCategoriesSuccess = categories => ({
  type: types.FETCH_RECORD_CATEGORIES_SUCCESS,
  payload: {
    categories,
  },
});

export const fetchRecordCategoriesFailure = () => ({
  type: types.FETCH_RECORD_CATEGORIES_FAILURE,
});

export const fetchScoreRecordList = type => ({
  type: types.FETCH_SCORE_RECORD_LIST,
  payload: {
    type,
  },
});
export const fetchScoreRecordListSuccess = records => ({
  type: types.FETCH_SCORE_RECORD_LIST_SUCCESS,
  payload: {
    records,
  },
});
export const fetchScoreRecordListFailure = () => ({
  type: types.FETCH_SCORE_RECORD_LIST_FAILURE,
});

export const changeRecordCategory = category => ({
  type: types.CHANGE_RECORD_CATEGORY,
  payload: {
    category,
  },
});

export const changeRecordCategoryType = type => ({
  type: types.CHANGE_RECORD_CATEGORY_TYPE,
  payload: {
    type,
  },
});

export const fetchRecordDetail = (subjectId, recordId, studentId) => ({
  type: types.FETCH_RECORD_DETAIL,
  payload: {
    subjectId,
    recordId,
    studentId,
  },
});

export const fetchRecordDetailSuccess = (record, series) => ({
  type: types.FETCH_RECORD_DETAIL_SUCCESS,
  payload: {
    record,
    series,
  },
});

export const fetchRecordDetailFailure = () => ({
  type: types.FETCH_RECORD_DETAIL_FAILURE,
});

export const toggleConceptChecked = ({ conceptId, subtopicId, isChecked }) => ({
  type: types.TOGGLE_RECORD_CONCEPT_CHECKED,
  payload: {
    conceptId,
    subtopicId,
    isChecked,
  },
});

export const toggleConceptCheckedSuccess = record => ({
  type: types.TOGGLE_RECORD_CONCEPT_CHECKED_SUCCESS,
  payload: {
    record,
  },
});

export const toggleConceptCheckedFailure = () => ({
  type: types.TOGGLE_RECORD_CONCEPT_CHECKED_FAILURE,
});

export const setStudentId = studentId => ({
  type: types.SET_STUDENT_ID,
  payload: { studentId },
});

export const setStudentName = studentName => ({
  type: types.SET_STUDENT_NAME,
  payload: { studentName },
});

const initalState = {
  loadingStatus: loadingState.EMPTY,
  recordDetailLoadingStatus: loadingState.EMPTY,
  records: [],
  categories: [],
  selectedCategory: undefined,
  selectedType: undefined,
  record: {
    answers: [],
    name: undefined,
    rank: undefined,
    score: undefined,
    summary: [],
    total_score: undefined,
    year: undefined,
  },
  series: {
    counts: [],
    scores: [],
  },
  conceptStatus: loadingState.EMPTY,
  // studentID is used when logged in user is TUTOR.
  studentId: 0,
  studentName: '',
};

const reducer = (state = initalState, action) => {
  switch (action.type) {
    case types.FETCH_RECORD_CATEGORIES:
      return {
        ...state,
        loadingStatus: loadingState.LOADING,
      };
    case types.FETCH_RECORD_CATEGORIES_SUCCESS:
      return {
        ...state,
        loadingStatus: loadingState.READY,
        categories: action.payload.categories,
      };
    case types.FETCH_SCORE_RECORD_LIST:
      return {
        ...state,
        loadingStatus: loadingState.LOADING,
      };
    case types.FETCH_SCORE_RECORD_LIST_SUCCESS:
      return {
        ...state,
        loadingStatus: loadingState.READY,
        records: action.payload.records,
      };
    case types.FETCH_SCORE_RECORD_LIST_FAILURE:
      return {
        ...state,
        loadingStatus: loadingState.ERROR,
        records: [],
      };
    case types.CHANGE_RECORD_CATEGORY:
      return {
        ...state,
        selectedCategory: action.payload.category,
      };
    case types.CHANGE_RECORD_CATEGORY_TYPE:
      return {
        ...state,
        selectedType: action.payload.type,
      };
    case types.FETCH_RECORD_DETAIL:
      return {
        ...state,
        recordDetailLoadingStatus: loadingState.LOADING,
      };
    case types.FETCH_RECORD_DETAIL_SUCCESS:
      return {
        ...state,
        recordDetailLoadingStatus: loadingState.READY,
        record: action.payload.record,
        series: action.payload.series,
      };
    case types.TOGGLE_RECORD_CONCEPT_CHECKED:
      return {
        ...state,
        conceptStatus: loadingState.LOADING,
      };
    case types.TOGGLE_RECORD_CONCEPT_CHECKED_SUCCESS:
      return {
        ...state,
        conceptStatus: loadingState.READY,
        record: action.payload.record,
      };
    case types.SET_STUDENT_ID:
      return {
        ...state,
        studentId: action.payload.studentId,
      };
    case types.SET_STUDENT_NAME:
      return {
        ...state,
        studentName: action.payload.studentName,
      };
    default:
      return state;
  }
};

export default reducer;

export const getSelectedCategory = state => state.scoreRecord.selectedCategory;
export const getCategories = state => state.scoreRecord.categories;
export const getRecords = state => state.scoreRecord.records;
export const getRecord = state => state.scoreRecord.record;
export const getLoadingStatus = state => state.scoreRecord.loadingStatus;
export const getRecordDetailLoadingStatus = state =>
  state.scoreRecord.recordDetailLoadingStatus;
export const getConceptStatus = state => state.scoreRecord.conceptStatus;
export const getSelectedType = state => state.scoreRecord.selectedType;
export const getIsSchoolCategory = createSelector(
  getSelectedCategory,
  category => !!category && category.name === SCHOOL
);
export const getDetailSeries = state => state.scoreRecord.series;
export const getStudentId = state => state.scoreRecord.studentId;
export const getStudentName = state => state.scoreRecord.studentName;



// WEBPACK FOOTER //
// ./app/redux/scoreRecord.js